// MS_1
const diseases = [
  "None",
  "Cardiovascular Disease",
  "Acute Cholecystitis",
  "Acute Kidney Injury",
  "Acute Pancreatitis",
  "Acute Respiratory Distress Syndrome",
  "Alcohol-Related Liver Disease",
  "Anal Fissure",
  "Anal Fistula",
  "Anorexia Nervosa",
  "Appendicitis",
  "Arthritis",
  "Autism",
  "Binge Eating Disorder",
  "Bone Cancer",
  "Breast Lumps",
  "Bronchitis",
  "Cerebral Palsy",
  "Cervical Cancer",
  "Chronic Kidney Disease",
  "Chronic Obstructive Pulmonary Disease (COPD)",
  "Chronic Pancreatitis",
  "Cirrhosis",
  "Colic",
  "Colon/Rectal Cancer",
  "Coronavirus",
  "Cystic Fibrosis",
  "Cystitis",
  "Diabetes Insipidus",
  "Diabetic Eye Screening",
  "Diabetic Ketoacidosis",
  "Diabetic Retinopathy",
  "Diverticular Disease And Diverticulitis",
  "Dysarthria (Difficulty Speaking)",
  "Dysentery",
  "Dyslexia",
  "Dysphagia (Swallowing Problems)",
  "Ear Infections",
  "Eating Disorders",
  "Epilepsy",
  "Erectile Dysfunction (Impotence)",
  "Excessive Daytime Sleepiness (Hypersomnia)",
  "Eye Cancer",
  "Gastritis",
  "Gestational Diabetes",
  "Goitre",
  "Gout",
  "Gum Disease",
  "Haemochromatosis",
  "Hay Fever",
  "Head And Neck Cancer",
  "Heart Attack",
  "Heart Block",
  "Heart Bypass",
  "Heart Disease (Coronary)",
  "Heart Failure",
  "Hepatitis",
  "Hepatitis A",
  "Hepatitis B",
  "Hepatitis C",
  "Hyperparathyroidism",
  "Hypertension",
  "Hyperthyroidism",
  "Hypoglycaemia (Low Blood Sugar)",
  "Hypoparathyroidism",
  "Hypotension, Low Blood Pressure",
  "Hypothyroidism",
  "Inflammatory Bowel Disease",
  "Iron Deficiency Anaemia",
  "Irritable Bowel Syndrome (IBS)",
  "Jaundice",
  "Keratosis Pilaris",
  "Kidney Cancer",
  "Kidney Infection",
  "Kidney Stones",
  "Lactose Intolerance",
  "Liver Cancer",
  "Liver Disease",
  "Lumps",
  "Lung Cancer",
  "Lupus",
  "Obesity",
  "Obsessive Compulsive Disorder (OCD)",
  "Obstructive Sleep Apnoea",
  "Osteoarthritis",
  "Osteoporosis",
  "Ovarian Cancer",
  "Ovarian Cyst",
  "Pneumonia",
  "Polio",
  "Polycystic Ovary Syndrome",
  "Pre-Eclampsia",
  "Prostate Problems",
  "Psoriasis",
  "Psoriatic Arthritis",
  "Reactive Arthritis",
  "Repetitive Strain Injury (RSI)",
  "Respiratory Tract Infections (RTIs)",
  "Restless Legs Syndrome",
  "Rheumatic Fever",
  "Rheumatoid Arthritis",
  "Thalassaemia",
  "Tourette'S Syndrome",
  "Type 1 Diabetes",
  "Type 2 Diabetes",
  "Urinary Tract Infections (UTIs)",
  "Varicose Eczema",
  "Varicose Veins",
  "Vasculitis",
  "Vertigo",
  "Vitamin B12 Or Folate Deficiency Anaemia",
];

// MS_3
export const symptoms = [
  "None",
  "Acid And Chemical Burns",
  "Alcohol Poisoning",
  "Altitude Sickness",
  "Anal Pain",
  "Angina",
  "Ankle Pain",
  "Arrhythmia",
  "Back Pain",
  "Bad Breath",
  "Bleeding From The Bottom (Rectal Bleeding)",
  "Eyelid Inflammation",
  "Blindness And Vision Loss",
  "Blisters",
  "Bloating",
  "Blood Clots",
  "Blood Groups",
  "Blood In Semen",
  "Blood In Urine",
  "Blue Or Grey Skin Or Lips (Cyanosis)",
  "Blushing",
  "Body Odour (BO)",
  "Boils",
  "Breast Pain",
  "Broken Ankle",
  "Broken Arm Or Wrist",
  "Broken Collarbone",
  "Broken Finger Or Thumb",
  "Broken Hip",
  "Broken Leg",
  "Broken Nose",
  "Broken Or Bruised Ribs",
  "Broken Toe",
  "Bulging Eyes (Exophthalmos)",
  "Burns And Scalds",
  "Chest Infection",
  "Chronic Pain",
  "Cluster Headaches",
  "Cold Sores",
  "Colour Vision Deficiency (Colour Blindness)",
  "Concussion",
  "Coughing Up Blood (Blood In Phlegm)",
  "Cuts And Grazes",
  "Dandruff",
  "Depression",
  "Diarrhoea",
  "Dizziness",
  "Double Vision",
  "Dry Eyes",
  "Dysphagia (Swallowing Problems)",
  "Early Menopause",
  "Early Or Delayed Puberty",
  "Elbow And Arm Pain",
  "Excessive Daytime Sleepiness (Hypersomnia)",
  "Excessive Hair Growth (Hirsutism)",
  "Excessive Sweating (Hyperhidrosis)",
  "Excessive Thirst",
  "Fainting",
  "Farting",
  "Feeling Of Something In Your Throat (Globus)",
  "Feeling Sick (Nausea)",
  "Female Genital Mutilation (FGM)",
  "Fever",
  "Finger Pain",
  "Floaters And Flashes In The Eyes",
  "Food Allergy",
  "Food Intolerance",
  "Food Poisoning",
  "Foot Drop",
  "Foot Pain",
  "Genital Symptoms",
  "Genital Warts",
  "Growing Pains",
  "Hair Loss",
  "Hallucinations And Hearing Voices",
  "Hamstring Injury",
  "Hand Pain",
  "Hand Tendon Repair",
  "Health Anxiety",
  "Heart Palpitations",
  "Heartburn And Acid Reflux",
  "Heat Exhaustion And Heatstroke",
  "Heat Rash (Prickly Heat)",
  "Heavy Periods",
  "Heel Pain",
  "Hiccups",
  "High Blood Pressure (Hypertension)",
  "High Blood Sugar (Hyperglycaemia)",
  "Hormone Headaches",
  "Hyperglycaemia (High Blood Sugar)",
  "Hypoglycaemia (Low Blood Sugar)",
  "Hypothermia",
  "Ingrown Hairs",
  "Insect Bites And Stings",
  "Insomnia",
  "Itchy Bottom",
  "Itchy Skin",
  "Joint Pain",
  "Knee Pain",
  "Lost Or Changed Sense Of Smell",
  "Low Blood Pressure (Hypotension)",
  "Low Blood Sugar (Hypoglycaemia)",
  "Loss Of Bowel Control",
  "Low Sex Drive (Loss Of Libido)",
  "Low Sperm Count",
  "Low White Blood Cell Count",
  "Metallic Taste",
  "Moles",
  "Mouth Ulcer",
  "Neck Pain",
  "Night Sweats",
  "Night Terrors And Nightmares",
  "Nipple Discharge",
  "Noise Sensitivity (Hyperacusis)",
  "Ovulation Pain",
  "Pain In The Back Of The Hand",
  "Pain In The Ball Of The Foot",
  "Pain In The Bottom Of The Foot",
  "Pain In The Palm Of The Hand",
  "Pain In The Top Of The Foot",
  "Pelvic Pain",
  "Period Pain",
  "PMS (Premenstrual Syndrome)",
  "Post-Mortem",
  "Post-Polio Syndrome",
  "Postmenopausal Bleeding",
  "Pressure Ulcers (Pressure Sores)",
  "Priapism (Painful Erections)",
  "Shoulder Impingement",
  "Shoulder Pain",
  "Smelly Feet",
  "Smelly Urine",
  "Snoring",
  "Social Anxiety (Social Phobia)",
  "Sore Or Dry Lips",
  "Sore Or White Tongue",
  "Stomach Ache",
  "Stopped Or Missed Periods",
  "Stress, Anxiety And Low Mood",
  "Stroke",
  "Sudden Confusion (Delirium)",
  "Swollen Ankles, Feet And Legs (Oedema)",
  "Swollen Arms And Hands (Oedema)",
  "Tailbone (Coccyx) Pain",
  "Tension Headaches",
  "Testicle Lumps And Swellings",
  "Testicle Pain",
  "Thumb Pain",
  "Tinnitus (Ringing In Ears)",
  "Tiredness And Fatigue",
  "Toe Pain",
  "Tongue-Tie",
  "Tooth Decay",
  "Tremor Or Shaking Hands",
  "Trigeminal Neuralgia (Facial Pain)",
  "Trigger Finger (Finger Stiffness)",
  "Twitching Eyes And Muscles",
  "Unintentional Weight Loss",
  "Vaginal Discharge",
  "Vaginal Dryness",
  "Vaginismus (Involuntary Vaginal Muscle Spasms)",
  "Vomiting Blood",
  "Vomiting",
  "Watering Eyes",
  "Wrist Pain",
];

export const options = [
  "None",
  "Achalasia",
  "Acoustic Neuroma (Vestibular Schwannoma)",
  "Actinic Keratoses (Solar Keratoses)",
  "Actinomycosis",
  "Acute Cholecystitis",
  "Acute Kidney Injury",
  "Acute Lymphoblastic Leukaemia",
  "Acute Myeloid Leukaemia",
  "Acute Pancreatitis",
  "Acute Respiratory Distress Syndrome",
  "Addison's Disease",
  "Adenoidectomy",
  "Age-Related Cataracts",
  "Age-Related Macular Degeneration (AMD)",
  "Agoraphobia",
  "Albinism",
  "Alcohol-Related Liver Disease",
  "Alkaptonuria",
  "Allergic Rhinitis",
  "Alzheimer's Disease",
  "Amblyopia",
  "Amyloidosis",
  "Anal Fissure",
  "Anal Fistula",
  "Androgen Insensitivity Syndrome",
  "Aneurysm (Abdominal Aortic)",
  "Angelman Syndrome",
  "Ankylosing Spondylitis",
  "Anorexia Nervosa",
  "Antiphospholipid Syndrome (APS)",
  "Antisocial Personality Disorder",
  "Anxiety Disorders in Children",
  "Appendicitis",
  "Arterial Thrombosis",
  "Arthritis",
  "Asbestosis",
  "Aspergillosis",
  "Asthma",
  "Astigmatism",
  "Ataxia",
  "Atherosclerosis",
  "Athlete's Foot",
  "Atopic Eczema",
  "Atrial Fibrillation",
  "Attention Deficit Hyperactivity Disorder (ADHD)",
  "Auditory Processing Disorder (APD)",
  "Autism",
  "Autosomal Dominant Polycystic Kidney Disease",
  "Autosomal Recessive Polycystic Kidney Disease",
  "Bacterial Vaginosis",
  "Baker's Cyst",
  "Balanitis",
  "Bartholin's Cyst",
  "Basal Cell Carcinoma, Skin Cancer",
  "Behçet's Disease",
  "Bell's Palsy",
  "Benign Brain Tumour (Non-Cancerous)",
  "Benign Prostate Enlargement",
  "Bile Duct Cancer (Cholangiocarcinoma)",
  "Binge Eating Disorder",
  "Bipolar Disorder",
  "Bird Flu",
  "Bladder Cancer",
  "Bladder Pain Syndrome (Interstitial Cystitis)",
  "Bladder Stones",
  "Body Dysmorphic Disorder (BDD)",
  "Bone Cancer",
  "Bone Cyst",
  "Botulism",
  "Bowel Incontinence",
  "Bowel Polyps",
  "Bowen's Disease",
  "Brain Abscess",
  "Brain Aneurysm",
  "Brain Death",
  "Brain Haemorrhage",
  "Brain Tumours",
  "Breast Abscess",
  "Breast Cancer in Men",
  "Breast Cancer in Women",
  "Breast Lumps",
  "Bronchiectasis",
  "Bronchiolitis",
  "Bronchitis",
  "Brucellosis",
  "Brugada Syndrome",
  "Bulimia",
  "Bullous Pemphigoid",
  "Bunions",
  "Cancer",
  "Cardiomyopathy",
  "Cardiovascular Disease",
  "Carpal Tunnel Syndrome",
  "Catarrh",
  "Cavernoma",
  "Cavernous Sinus Thrombosis",
  "Cellulitis",
  "Cerebral Palsy",
  "Cervical Cancer",
  "Cervical Spondylosis",
  "Charcot-Marie-Tooth Disease",
  "Charles Bonnet Syndrome",
  "Chiari Malformation",
  "Chickenpox",
  "Chilblains",
  "Chlamydia",
  "Cholera",
  "Cholesteatoma",
  "Chronic Fatigue Syndrome (ME/CFS)",
  "Chronic Kidney Disease",
  "Chronic Lymphocytic Leukaemia",
  "Chronic Myeloid Leukaemia",
  "Chronic Obstructive Pulmonary Disease (COPD)",
  "Chronic Pancreatitis",
  "Chronic Traumatic Encephalopathy",
  "Cirrhosis",
  "Claustrophobia",
  "Cleft Lip and Palate",
  "Clinical Depression",
  "Clostridium Difficile (C. Diff) Infection",
  "Coeliac Disease",
  "Colic",
  "Colon/Rectal Cancer",
  "Compartment Syndrome",
  "Complex Regional Pain Syndrome",
  "Congenital Heart Disease",
  "Conjunctivitis",
  "Contact Dermatitis",
  "Corns and Calluses",
  "Coronavirus",
  "Corticobasal Degeneration",
  "Costochondritis",
  "Cradle Cap",
  "Craniosynostosis",
  "Creutzfeldt-Jakob Disease",
  "Crohn's Disease",
  "Cushing's Syndrome",
  "Cyclical Vomiting Syndrome",
  "Cyclospora",
  "Cyclothymia",
  "Cystic Fibrosis",
  "Cystitis",
  "Cytomegalovirus (CMV)",
  "Dementia (Frontotemporal)",
  "Dementia with Lewy Bodies",
  "Dengue",
  "Dental Abscess",
  "Depression",
  "Developmental Coordination Disorder (Dyspraxia) in Children",
  "Diabetes",
  "Diabetes Insipidus",
  "Diabetic Eye Screening",
  "Diabetic Ketoacidosis",
  "Diabetic Retinopathy",
  "Differences in Sex Development",
  "DiGeorge Syndrome (22q11 Deletion)",
  "Diphtheria",
  "Discoid Eczema",
  "Disorders of Consciousness",
  "Dissociative Disorders",
  "Diverticular Disease and Diverticulitis",
  "Down's Syndrome",
  "Dupuytren's Contracture",
  "DVT (Deep Vein Thrombosis)",
  "Dwarfism",
  "Dysarthria (Difficulty Speaking)",
  "Dysentery",
  "Dyslexia",
  "Dysphagia (Swallowing Problems)",
  "Dyspraxia (Developmental Coordination Disorder) in Adults",
  "Dystonia",
  "Ear Infections",
  "Eating Disorders",
  "Ebola Virus Disease",
  "Ectropion",
  "Edwards' Syndrome (Trisomy 18)",
  "Ehlers-Danlos Syndromes",
  "Embolism",
  "Emollients",
  "Empyema",
  "Encephalitis",
  "Endocarditis",
  "Endometrial/Womb Cancer",
  "Endometriosis",
  "Epidermolysis Bullosa",
  "Epididymitis",
  "Epiglottitis",
  "Epilepsy",
  "Erectile Dysfunction (Impotence)",
  "Erythema Multiforme",
  "Erythema Nodosum",
  "Erythrocytosis",
  "Erythromelalgia",
  "Ewing Sarcoma",
  "Excessive Daytime Sleepiness (Hypersomnia)",
  "Eye Cancer",
  "Eye Cancer in Children",
  "Eye Infection (Herpes)",
  "Femoral Hernia Repair",
  "Fibroids",
  "Fibromyalgia",
  "Fits (Children with Fever)",
  "Fits (Seizures)",
  "Floaters and Flashes in the Eyes",
  "Fluoride",
  "Foetal Alcohol Spectrum Disorder",
  "Functional Neurological Disorder",
  "Fungal Nail Infection",
  "Gallbladder Cancer",
  "Ganglion Cyst",
  "Gangrene",
  "Gastritis",
  "Gastroparesis",
  "Gender Dysphoria",
  "Generalised Anxiety Disorder in Adults",
  "Genital Herpes",
  "Genital Warts",
  "Gestational Diabetes",
  "Giardiasis",
  "Gigantism",
  "Gilbert's Syndrome",
  "Glandular Fever",
  "Glaucoma",
  "Glomerulonephritis",
  "Glue Ear",
  "Glutaric Aciduria Type 1",
  "Goitre",
  "Gonorrhoea",
  "Gout",
  "Granuloma Annulare",
  "Granulomatosis with Polyangiitis",
  "Group B Strep",
  "Guillain-Barré Syndrome",
  "Gum Disease",
  "Haemochromatosis",
  "Haemophilia",
  "Haemophilus Influenzae Type B (Hib)",
  "Hairy Cell Leukaemia",
  "Hand, Foot and Mouth Disease",
  "Hay Fever",
  "Head and Neck Cancer",
  "Head Injury and Concussion",
  "Heart Attack",
  "Heart Block",
  "Heart Bypass",
  "Heart Disease (Coronary)",
  "Heart Failure",
  "Heartburn and Acid Reflux",
  "Henoch-Schönlein Purpura (HSP)",
  "Hepatitis",
  "Hepatitis A",
  "Hepatitis B",
  "Hepatitis C",
  "Hereditary Haemorrhagic Telangiectasia (HHT)",
  "Hereditary Neuropathy with Pressure Palsies (HNPP)",
  "Herpangina",
  "Herpes Simplex Eye Infection",
  "Herpes Simplex Virus",
  "Hidradenitis Suppurativa",
  "High Blood Pressure",
  "Hirschsprung's Disease",
  "HIV",
  "Hodgkin Lymphoma",
  "Huntington's Disease",
  "Hydrocephalus",
  "Hydronephrosis",
  "Hyperhidrosis",
  "Hyperparathyroidism",
  "Hypertrophic Cardiomyopathy",
  "Hyperthyroidism",
  "Hypoparathyroidism",
  "Hypoplastic Left Heart Syndrome",
  "Hypothyroidism",
  "Idiopathic Pulmonary Fibrosis",
  "Immune Thrombocytopenia",
  "Impetigo",
  "Infective Endocarditis",
  "Inflammatory Bowel Disease (IBD)",
  "Influenza",
  "Inguinal Hernia",
  "Insomnia",
  "Insulinoma",
  "Intestinal Pseudo-Obstruction",
  "Interstitial Lung Disease",
  "Iron Deficiency Anaemia",
  "Irritable Bowel Syndrome (IBS)",
  "Ischaemic Heart Disease",
  "Jaundice",
  "Jellyfish Stings",
  "Joint Hypermobility Syndrome",
  "Juvenile Idiopathic Arthritis",
  "Kaposi's Sarcoma",
  "Kawasaki Disease",
  "Kidney Cancer",
  "Kidney Stones",
  "Klinefelter Syndrome",
  "Knee Pain",
  "Labyrinthitis",
  "Lactose Intolerance",
  "Laryngeal (Larynx) Cancer",
  "Legionnaires' Disease",
  "Lennox-Gastaut Syndrome",
  "Leprosy",
  "Leptospirosis",
  "Leukaemia",
  "Lichen Planus",
  "Lichen Sclerosus",
  "Lipid Disorders",
  "Listeriosis",
  "Liver Cancer",
  "Liver Cirrhosis",
  "Liver Disease",
  "Liver Transplant",
  "Locked-In Syndrome",
  "Lung Cancer",
  "Lung Transplant",
  "Lupus",
  "Lymphoedema",
  "Lymphoma",
  "Lyme Disease",
  "Lymphocytic Colitis",
  "Meniere's Disease",
  "Marfan Syndrome",
  "Mastocytosis",
  "Mastoiditis",
  "Measles",
  "Medullary Thyroid Cancer",
  "Melanoma",
  "Meniere's Disease",
  "Menopause",
  "Menorrhagia (Heavy Periods)",
  "Mental Health Conditions",
  "Metabolic Disorders",
  "Migraine",
  "Mitochondrial Disease",
  "MND (Motor Neurone Disease)",
  "Mononucleosis",
  "Morning Sickness",
  "Morphea",
  "Mouth Cancer",
  "Multiple Sclerosis",
  "Mumps",
  "Myalgic Encephalomyelitis (ME)",
  "Myasthenia Gravis",
  "Myocarditis",
  "Myopia (Short-Sightedness)",
  "Narcolepsy",
  "Nasal Polyps",
  "Nausea and Vomiting",
  "Neck Pain",
  "Nephrotic Syndrome",
  "Neuroblastoma",
  "Neuroendocrine Tumours",
  "Neuromyelitis Optica",
  "Night Blindness",
  "Non-Hodgkin Lymphoma",
  "Obesity",
  "Obsessive Compulsive Disorder (OCD)",
  "Obstructive Sleep Apnea",
  "Occipital Neuralgia",
  "Oesophageal Cancer",
  "Oesophagitis",
  "Olfactory Nerve Disorders",
  "Olfactory Neuroblastoma",
  "Oligodendroglioma",
  "Onchocerciasis (River Blindness)",
  "Optic Neuritis",
  "Osteoarthritis",
  "Osteomalacia",
  "Osteomyelitis",
  "Osteonecrosis",
  "Osteoporosis",
  "Otitis Externa",
  "Otitis Media",
  "Otosclerosis",
  "Ovarian Cancer",
  "Overactive Bladder",
  "Paget's Disease",
  "Pancreatic Cancer",
  "Panic Disorder",
  "Parkinson's Disease",
  "Parvovirus Infection",
  "Patellar Tendonitis",
  "Pelvic Congestion Syndrome",
  "Pelvic Inflammatory Disease",
  "Pemphigus Vulgaris",
  "Peptic Ulcers",
  "Peripheral Neuropathy",
  "Peritonitis",
  "Personality Disorders",
  "Peyronie's Disease",
  "Phimosis",
  "Pilonidal Cyst",
  "Pityriasis Rosea",
  "Pityriasis Versicolor",
  "Plantar Fasciitis",
  "Plasmacytoma",
  "Pneumonia",
  "Pneumothorax",
  "Poliomyelitis",
  "Polymyalgia Rheumatica",
  "Polycystic Kidney Disease",
  "Polycystic Ovary Syndrome (PCOS)",
  "Polycythemia Vera",
  "Porphyria",
  "Portal Hypertension",
  "Postpartum Depression",
  "Prader-Willi Syndrome",
  "Primary Aldosteronism",
  "Primary Biliary Cirrhosis",
  "Primary Hyperparathyroidism",
  "Primary Sclerosing Cholangitis",
  "Prion Disease",
  "Progressive Supranuclear Palsy",
  "Prostate Cancer",
  "Psoriatic Arthritis",
  "Psoriasis",
  "Pulmonary Arterial Hypertension",
  "Pulmonary Embolism",
  "Pulmonary Fibrosis",
  "Pulmonary Hypertension",
  "Purpura",
  "Q Fever",
  "Rabies",
  "Raynaud's Disease",
  "Rectal Cancer",
  "Reflex Sympathetic Dystrophy",
  "Reflux",
  "Reiter's Syndrome",
  "Renal Cancer",
  "Renal Cell Carcinoma",
  "Renal Failure",
  "Respiratory Syncytial Virus",
  "Restless Legs Syndrome",
  "Retinal Detachment",
  "Retinitis Pigmentosa",
  "Retinoblastoma",
  "Rett Syndrome",
  "Rhabdomyosarcoma",
  "Rheumatic Fever",
  "Rheumatoid Arthritis",
  "Rickets",
  "Ringworm",
  "Rosacea",
  "Rotator Cuff Injury",
  "Rubella",
  "Salivary Gland Cancer",
  "Sarcoidosis",
  "Scabies",
  "Scarlet Fever",
  "Schizophrenia",
  "Scleroderma",
  "Scoliosis",
  "Seizures",
  "Sexually Transmitted Diseases",
  "Shigellosis",
  "Shingles",
  "Short Bowel Syndrome",
  "Short-Sightedness (Myopia)",
  "Sickle Cell Disease",
  "Sjogren's Syndrome",
  "Skin Cancer",
  "Sleep Apnea",
  "Small Intestinal Bacterial Overgrowth",
  "Smallpox",
  "Soft Tissue Sarcoma",
  "Spina Bifida",
  "Spinal Cord Injury",
  "Spinal Muscular Atrophy",
  "Spondylolisthesis",
  "Spondylosis",
  "Sporotrichosis",
  "Squamous Cell Carcinoma",
  "Stevens-Johnson Syndrome",
  "Stickler Syndrome",
  "Stomach Cancer",
  "Strabismus",
  "Streptococcal Infections",
  "Stroke",
  "Subarachnoid Hemorrhage",
  "Sudden Infant Death Syndrome",
  "Suicide",
  "Swine Flu",
  "Syphilis",
  "Systemic Lupus Erythematosus",
  "Systemic Sclerosis",
  "Tachycardia",
  "Takayasu Arteritis",
  "Tay-Sachs Disease",
  "Temporal Arteritis",
  "Tennis Elbow",
  "Tension Headache",
  "Testicular Cancer",
  "Thalassemia",
  "Thyroid Cancer",
  "Thyroid Disease",
  "Tinnitus",
  "Tonsillitis",
  "Tooth Decay",
  "Tourette Syndrome",
  "Toxoplasmosis",
  "Transposition of the Great Arteries",
  "Transverse Myelitis",
  "Trachoma",
  "Trichotillomania",
  "Trisomy 13",
  "Trisomy 18",
  "Trisomy X",
  "Tuberculosis",
  "Turner Syndrome",
  "Typhoid Fever",
  "Ulcerative Colitis",
  "Undescended Testicle",
  "Ureteral Stones",
  "Urethritis",
  "Urinary Incontinence",
  "Urinary Retention",
  "Urinary Tract Infection",
  "Urticaria",
  "Uterine Cancer",
  "Uterine Fibroids",
  "Varicocele",
  "Varicose Veins",
  "Vascular Dementia",
  "Ventricular Fibrillation",
  "Ventricular Septal Defect",
  "Vertigo",
  "Viral Hemorrhagic Fever",
  "Viral Hepatitis",
  "Viral Infections",
  "Vitamin B12 Deficiency",
  "Vitamin D Deficiency",
  "Von Willebrand Disease",
  "Vulvodynia",
  "Warts",
  "Wegener's Granulomatosis",
  "West Nile Virus",
  "Whipple's Disease",
  "Wilson's Disease",
  "Wolff-Parkinson-White Syndrome",
  "Yellow Fever",
  "Yersiniosis",
  "Zika Virus",
];

export const foodList = [
  {
    Food: "White Rice",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 2,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Wheat (As Chapati/Roti)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Jowar (Sorghum)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Bajra (Pearl Millet)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Ragi (Finger Millet)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Corn (Maize)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Barley",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Oats",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Quinoa",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Semolina (Sooji/Rava)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Buckwheat (Kuttu)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Brown Rice",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 3,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Broken Wheat (Dalia)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Amaranth (Rajgira)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Wild Rice",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 0,
      " Joint Pain": 2,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Millet",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 0,
      Hypothyroidism: 2,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Sago (Sabudana)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Poha (Flattened Rice)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Puffed Rice (Murmura)",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Bulgur Wheat",
    Category: "Cereals & Whole Grains",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Toor Dal (Pigeon Peas)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Moong Dal (Green Gram)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Urad Dal (Black Gram)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Chana Dal (Split Chickpeas)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Masoor Dal (Red Lentils)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Rajma (Kidney Beans)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 3,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Black-Eyed Peas (Lobia)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Chickpeas (Garbanzo Beans)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Yellow Split Peas",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Green Peas",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Soybean",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Horse Gram (Kulthi)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Black Gram (Whole Urad)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Moth Beans",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Lima Beans",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 0,
      " Joint Pain": 1,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Navy Beans",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 0,
      " Joint Pain": 1,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Pinto Beans",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Adzuki Beans",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Fava Beans",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Mung Beans (Whole Green Gram)",
    Category: "Pulses & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Cashews",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Almonds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Peanuts",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 2,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Pistachios",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Walnuts",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Pine Nuts",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Macadamia Nuts",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Brazil Nuts",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Hazelnuts",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Pecans",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 0,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Coconut",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Chironji",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 0,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Pumpkin Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Sunflower Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Watermelon Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Flax Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Chia Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Sesame Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Poppy Seeds",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Makhana (Fox Nuts)",
    Category: "Nuts & Legumes",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Mangoes",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 2,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Bananas",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Apples",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Grapes",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Oranges",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Papayas",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Watermelons",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Guavas",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Pineapples",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Pomegranates",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Chikoos (Sapodilla)",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 0,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Custard Apples",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Jackfruit",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 3,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Litchis",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 0,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Strawberries",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Figs",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Jamun (Indian Blackberry)",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Kiwi",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Pears",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Plums",
    Category: "Fruits",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Potatoes",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Onions",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Tomatoes",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Spinach",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Cauliflower",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Cabbage",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Okra (Bhindi)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Eggplant (Brinjal)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Bell Peppers",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Carrots",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Green Beans",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Peas",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Bitter Gourd (Karela)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Bottle Gourd (Lauki)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Ridge Gourd (Turai)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Cucumber",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Radish",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Beetroot",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Fenugreek Leaves (Methi)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Ivy Gourd (Tindora)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Amaranth Leaves (Chaulai)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Mustard Greens (Sarson Ka Saag)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Collard Greens",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Drumsticks (Moringa)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Turnips",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Pumpkin",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Ash Gourd (Petha)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Snake Gourd (Chichinda)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Cluster Beans (Guar)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Indian Broad Beans (Sem)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Yam (Suran)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Colocasia Leaves (Arbi Ke Patte)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Sweet Potato",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Pointed Gourd (Parwal)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Lotus Stem (Kamal Kakdi)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Green Chillies",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 3,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Coriander Leaves (Dhania)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Mint Leaves (Pudina)",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Curry Leaves",
    Category: "Vegetables",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 0,
      " Joint Pain": 1,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Yogurt (Curd)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Milk",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Paneer (Cottage Cheese)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Ghee (Clarified Butter)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 2,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Butter",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 3,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Cream",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Buttermilk (Chaas)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Khoa (Reduced Milk Solids)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Cheese (Various Types)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Lassi (Yogurt Drink)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 3,
      Constipation: 3,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Condensed Milk",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Evaporated Milk",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Kefir",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Sour Cream",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Cream Cheese",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Ricotta Cheese",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Whey",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Casein",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 0,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Clotted Cream (Malai)",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Skimmed Milk Powder",
    Category: "Dairy",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Chicken",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Fish (Various Types)",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Mutton (Goat Meat)",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Lamb",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Duck",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Quail",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 0,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 0,
      "Chronic Pain": 0,
      "Wrist Pain": 0,
      "Neck Pain": 0,
    },
  },
  {
    Food: "Turkey",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Eggs",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 1,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Prawns",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Crabs",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Lobster",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Squid",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Mussels",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Clams",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Oysters",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 2,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Goat Liver",
    Category: "Meat",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 3,
      " Heartburn And Acid Reflux": 3,
      Constipation: 3,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Packaged Foods",
    Category: "Miscellaneous",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 3,
      " Night Sweats": 3,
      "High Blood Pressure (Hypertension)": 3,
      " Heartburn And Acid Reflux": 3,
      Constipation: 3,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Sauces & Ketchups",
    Category: "Miscellaneous",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 3,
      " Night Sweats": 3,
      "High Blood Pressure (Hypertension)": 3,
      " Heartburn And Acid Reflux": 3,
      Constipation: 3,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Pickles",
    Category: "Miscellaneous",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 3,
      " Night Sweats": 3,
      "High Blood Pressure (Hypertension)": 3,
      " Heartburn And Acid Reflux": 3,
      Constipation: 3,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Masala Chai (Spiced Tea)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Cutting Chai (Strong, Small Serving)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Lemon Tea",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Ginger Tea (Adrak Chai)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Cardamom Tea (Elaichi Chai)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Green Tea",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Black Tea",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Kashmiri Kahwa (Green Tea With Spices And Nuts)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Butter Tea (Popular In Ladakh)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Filter Coffee (South Indian Style)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Instant Coffee",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Black Coffee",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Milk Coffee",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Cold Coffee",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 3,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Cappuccino",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Espresso",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Latte",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 2,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Badam Milk (Almond Milk)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 0,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Nimbu Pani (Lemon Water/Lemonade)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Aam Panna (Raw Mango Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Watermelon Juice",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Orange Juice",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Mosambi Juice (Sweet Lime)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Sugarcane Juice",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 1,
      "Chest Infection": 3,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Coconut Water",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Jaljeera (Cumin-Based Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 0,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Rooh Afza (Rose-Flavored Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 3,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Sharbat (Sweet Fruit Syrup-Based Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 2,
      "Chest Infection": 3,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Kokum Juice (Solkadhi In Goa/Maharashtra)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 0,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Kanji (Fermented Carrot Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 3,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Bel Ka Sharbat (Wood Apple Juice)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 2,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Nannari Sarbath (Sarasaparilla Drink From South India)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 3,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 0,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Falooda (Rose-Flavored Dessert Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 3,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Masala Soda",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 3,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Jeera (Cumin) Soda",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 3,
      Bloating: 3,
      "Chest Infection": 3,
      " Joint Pain": 3,
      " Fever": 3,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 3,
      "Chronic Pain": 3,
      "Wrist Pain": 3,
      "Neck Pain": 3,
    },
  },
  {
    Food: "Fruit Beer (Non-Alcoholic Carbonated Fruit Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 2,
      " Fever": 0,
      Hypothyroidism: 3,
      " Night Sweats": 3,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 3,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Iced Tea (Various Flavors)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 2,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Smoothies",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 2,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 3,
      " Night Sweats": 3,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Fresh Fruit Milkshakes",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 2,
      Bloating: 1,
      "Chest Infection": 2,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 3,
      " Night Sweats": 3,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Sattu Drink (Roasted Gram Flour Drink)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Ragi Malt",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 1,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Turmeric Milk (Haldi Doodh)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
  {
    Food: "Jal Jeera (Cumin Water)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 2,
      " Fever": 1,
      Hypothyroidism: 0,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 0,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Lemon And Honey Water",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 1,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 2,
      " Night Sweats": 2,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 0,
      Constipation: 2,
      "Back Pain": 1,
      "Chronic Pain": 1,
      "Wrist Pain": 1,
      "Neck Pain": 1,
    },
  },
  {
    Food: "Vegetable Juices (Bitter Gourd, Bottle Gourd, Etc.)",
    Category: "Beverages",
    Properties: {
      "High Blood Sugar (Hyperglycaemia)": 1,
      Bloating: 2,
      "Chest Infection": 1,
      " Joint Pain": 1,
      " Fever": 1,
      Hypothyroidism: 1,
      " Night Sweats": 1,
      "High Blood Pressure (Hypertension)": 0,
      " Heartburn And Acid Reflux": 1,
      Constipation: 1,
      "Back Pain": 2,
      "Chronic Pain": 2,
      "Wrist Pain": 2,
      "Neck Pain": 2,
    },
  },
];

export const chiefComplaints = [
  "Abdominal Pain",
  "Acid Reflux",
  "Anxiety",
  "Appetite Changes",
  "Back Pain",
  "Bleeding",
  "Bloating",
  "Breathing Difficulties",
  "Chest Pain",
  "Cognitive Changes",
  "Coughing",
  "Depression",
  "Diarrhea",
  "Vertigo",
  "Tinnitus",
  "Edema",
  "Vision changes",
  "Fatigue",
  "Fever",
  "Gastrointestinal Problems",
  "Female Sexual Health Symptoms",
  "Headache",
  "Sleep Issues",
  "Joint Issues",
  "Kidney Related Symptoms",
  "Liver Related Symptoms",
  "Lung Related Symptoms",
  "Nose and Sinus Problems",
  "Oral Health Problems",
  "Mental Health Symptoms",
  "Neurological Symptoms",
  "Coordination problems",
  "Memory problems",
  "Rashes",
  "Male Sexual Health Symptoms",
  "Vomiting",
  "Skin Problems",
  "Throat Problems",
  "Urinary Symptoms",
  "Vision Problems",
  "Hair Problems",
  "Pain",
  "Misc",
  "Cramping",
  "Bloating",
  "Tender",
  "Burning Sensation In Chest/Throat",
  "Food Or Liquid Coming Back Up Into The Mouth",
  "Difficulty Swallowing",
  "Chronic Cough",
  "Excessive Worry",
  "Restlessness",
  "Racing Thoughts",
  "Rapid Heartbeat",
  "Sweating",
  "Trembling",
  "Difficulty Concentrating",
  "Increased Or Decreased Hunger",
  "Changes In Food Preferences",
  "Early Satiety",
  "Weight Fluctuations",
  "Lost Or Changed Sense Of Smell",
  "Metallic Taste",
  "Bruising",
  "Bleeding Gums",
  "Nosebleeds",
  "Unusual Vaginal Bleeding",
  "Bleeding From The Bottom (Rectal Bleeding)",
  "Vomiting",
  "Abdominal Distension",
  "Feeling Of Fullness",
  "Gas",
  "Discomfort",
  "Pain",
  "Nausea",
  "Changes In Bowel Movements",
  "Shortness Of Breath",
  "Wheezing",
  "Rapid Breathing",
  "Labored Breathing",
  "Unable To Take Deep Breaths",
  "Anxiety",
  "Dizziness",
  "Memory Problems",
  "Confusion",
  "Difficulty Concentrating",
  "Poor Judgment",
  "Changes In Awareness",
  "Mental Fog",
  "Persistent Sadness",
  "Loss Of Interest",
  "Hopelessness",
  "Guilt",
  "Sleep Changes",
  "Appetite Changes",
  "Fatigue",
  "Aches And Pains",
  "Cramping",
  "Urgency",
  "Dehydration",
  "Nausea",
  "Dizziness",
  "Spinning Sensation",
  "Lightheadedness",
  "Unsteadiness",
  "Balance Problems",
  "Nausea",
  "Vision Changes",
  "Hearing Changes",
  "Ear Problems",
  "Pain",
  "Discharge",
  "Ringing In Ear",
  "Hearing Changes",
  "Pressure Sensation",
  "Itching",
  "Swelling",
  "Eye Problems",
  "Weakness",
  "Lethargy",
  "Fever",
  "Chills",
  "Sweating",
  "Body Aches",
  "Dehydration",
  "Nausea",
  "Vomiting",
  "Acid Reflux",
  "Indigestion",
  "Gas",
  "Bloating",
  "Changes In Bowel Habits",
  "Farting",
  "Food Poisoning",
  "Loss Of Bowel Control",
  "Constipation",
  "Menstrual Changes",
  "Vaginal Discharge",
  "Pelvic Pain",
  "Irregular Bleeding",
  "Breast Changes",
  "Sexual Dysfunction",
  "Early Menopause",
  "Excessive Hair Growth",
  "Early Or Delayed Puberty",
  "Heavy Periods",
  "Vaginal Dryness",
  "Period Pain",
  "Premenstrual Syndrome",
  "Stopped Or Missed Periods",
  "Postmenopausal Bleeding",
  "Nipple Discharge",
  "Sleep Apnea",
  "Restless Legs",
  "Night Sweats",
  "Sleep Walking",
  "Nightmares",
  "Insomnia",
  "Night Terrors",
  "Excessive Daytime Sleepiness",
  "Pain",
  "Stiffness",
  "Swelling",
  "Reduced Range Of Motion",
  "Warmth",
  "Redness",
  "Back Pain",
  "Changes In Urination",
  "Swelling",
  "Fatigue",
  "Nausea",
  "Blood In Urine",
  "Jaundice",
  "Abdominal Pain",
  "Fatigue",
  "Itching",
  "Dark Urine",
  "Light Colored Stools",
  "Cough",
  "Shortness Of Breath",
  "Chest Pain",
  "Wheezing",
  "Mucus Production",
  "Night Sweats",
  "Congestion",
  "Runny Nose",
  "Pressure",
  "Loss Of Smell",
  "Nosebleeds",
  "Tooth Pain",
  "Gum Problems",
  "Bad Breath",
  "Mouth Sores",
  "Dry Mouth",
  "Jaw Pain",
  "Cold Sores",
  "Mouth Ulcer",
  "Anxiety",
  "Depression",
  "Mood Swings",
  "Changes In Behavior",
  "Sleep Problems",
  "Appetite Changes",
  "Muscle Problems",
  "Pain",
  "Weakness",
  "Spasms",
  "Twitching",
  "Stiffness",
  "Concentration Issues",
  "Headaches",
  "Dizziness",
  "Numbness",
  "Tingling",
  "Weakness",
  "Tremor Or Shaking Hands",
  "Finger Stiffness",
  "Speech Changes",
  "Vision Changes",
  "Respiratory Symptoms",
  "Cough",
  "Shortness Of Breath",
  "Wheezing",
  "Chest Pain",
  "Mucus Production",
  "Rapid Breathing",
  "Raised",
  "Flat",
  "Itchy",
  "Painful",
  "Blistering",
  "Dysfunction",
  "Pain",
  "Changes In Libido",
  "Discharge",
  "Sores",
  "Itching",
  "Low Sperm Count",
  "Painful Erections",
  "Testicle Lumps And Swellings",
  "Testicle Pain",
  "Vomiting",
  "Nausea",
  "Abdominal Pain",
  "Dizziness",
  "Weakness",
  "Rashes",
  "Itching",
  "Dryness",
  "Changes In Color",
  "Growths",
  "Sores",
  "Fever",
  "Chills",
  "Night Sweats",
  "Heat Intolerance",
  "Cold Intolerance",
  "Flushing",
  "Boils",
  "Moles",
  "Pain",
  "Hoarseness",
  "Persistent Cough",
  "Dysphagia",
  "Foreign Body Sensation",
  "Frequency",
  "Urgency",
  "Pain",
  "Blood In Urine",
  "Incomplete Emptying",
  "Incontinence",
  "Blurred Vision",
  "Double Vision",
  "Eye Pain",
  "Light Sensitivity",
  "Floaters",
  "Vision Loss",
  "Watering Eyes",
  "Twitching Eyes And Muscles",
  "Dandruff",
  "Hair Loss",
  "Split Ends",
  "Ankle Pain",
  "Breast Pain",
  "Elbow And Arm Pain",
  "Finger Pain",
  "Hand Pain",
  "Heel Pain",
  "Pain In The Back Of The Hand",
  "Pain In The Ball Of The Foot",
  "Pain In The Bottom Of The Foot",
  "Pain In The Palm Of The Hand",
  "Pain In The Top Of The Foot",
  "Shoulder Pain",
  "Tailbone (Coccyx) Pain",
  "Thumb Pain",
  "Toe Pain",
  "Facial Pain",
  "Wrist Pain",
  "Neck Pain",
  "Excessive Sweating",
  "Excessive Thirst",
  "Hypothermia",
  "High Blood Pressure",
  "High Blood Sugar",
  "Low Blood Pressure",
  "Low Blood Sugar",
];
export default diseases;
